<template>
  <transition name="fade" mode="out-in">
    <div class="col-span-full sm:col-span-full md:col-span-7 pb-8">
      <h1 class="text-t1 mb-4">Underhåll</h1>

      <div class="col-span-full flex flex-col gap-2 md:col-span-7">
        <div
          class="mb-4 w-fit rounded-[15px] bg-primary-10 p-4"
          v-if="webapp_config.msg.measures_disclaimer_text"
        >
          <h3 class="text-t6 mb-4" v-html="webapp_config.msg.measures_disclaimer_title"></h3>
          <p v-html="webapp_config.msg.measures_disclaimer_text"></p>
        </div>

        <div class="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2">
          <WhatIsMaintenance />
          <OrderMaintenance />
        </div>

        <div v-if="isLoading">
          <CardLoaderSmall class="flex-1 flex-col" />
        </div>


        <MaintenancePlan
          v-if="!isLoading"
          class="col-span-full"
          :preamble-text="webapp_config.msg.measures_preamble"
          :multipleContracts="multipleContracts"
          :contracts="contracts"
          :loaded="measuresLoaded"
          :measures="measures"
          :show-error="!isLoading && !measures.length && contractSelected"
          v-model="selectedContract"
        />

      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/ui/loader';
import WhatIsMaintenance from './what-is-maintenance.vue';
import OrderMaintenance from './order-maintenance.vue';
import MaintenancePlan from './maintenance-plan.vue';
import GeneralMixin from '@/mixins/general';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';

export default {
  name: 'Measures',
  mixins: [GeneralMixin],
  components: {
    Loader,
    WhatIsMaintenance,
    OrderMaintenance,
    MaintenancePlan,
    CardLoaderSmall,
  },
  data() {
    return {
      measures: this.$store.cache.state.measures || [],
      contractSelected: false,
      contracts: [],
      multipleContracts: false,
      isLoading: true,
      selectedContract: null,
      measuresLoaded: false
      // testAlwaysLoading: true,
    };
  },
  computed: {
    ...mapGetters(['authStatus', 'config', 'webapp_config', 'measures']),
  },
  created() {
      return this.$store.cache
        .dispatch('getConfig')
        .then(() => {
          if (this.authStatus) {
            this.$store.cache.dispatch('getApartmentNumbers').then((result) => {
              this.isLoading = false;
              if (result.length == 1) {

                this.contractSelected = true;
                this.contracts = result;
                this.loadMeasures(result[0].rentalObjectCode);

              } else if (result.length > 1) {
                this.multipleContracts = true;

                this.contracts = result.map((o) => {
                  return {
                    address: o.rentalObject.address1 + ' - ' + o.textstatus,
                    contractNumber: o.rentalObjectCode,
                    label: o.rentalObject.address1,
                    value: o.rentalObjectCode
                  };
                });
              }
            });
          }
        })
  },
  watch: {
    selectedContract(contract) {
      if (contract) {
        this.loadMeasures(contract);
      }
    }
  },

  methods: {
    loadMeasures(id) {
      this.isLoading = true;
      return this.$store.cache
        .dispatch('fetchMeasures', id)
        .then((response) => {
          this.measures = response;
          this.isLoading = false;
          this.measuresLoaded = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
